import { useLanguage } from '@/context/language-context';

export function getLocalizedField(obj: any, fieldName: string, language?: 'en' | 'fr'): string {
  if (!obj) return '';
  const lang = language || 'en';
  const localizedField = `${fieldName}${lang === 'fr' ? 'French' : 'English'}`;
  // Case-insensitive property lookup
  const foundKey = Object.keys(obj).find(
    k => k.toLowerCase() === localizedField.toLowerCase()
  );

  if (foundKey && obj[foundKey]) return obj[foundKey];
  // Fallback: try case-insensitive base field
  const baseKey = Object.keys(obj).find(
    k => k.toLowerCase() === fieldName.toLowerCase()
  );
  if (baseKey && obj[baseKey]) return obj[baseKey];
  return '';
}

// Helper hook for components that need to use getLocalizedField with current language
export function useLocalizedField() {
  const { language } = useLanguage();
  return (obj: any, fieldName: string) => getLocalizedField(obj, fieldName, language);
}

// Helper function to get localized value from an object with English/French fields
export function getLocalizedValue<T extends { [key: string]: any }>(
  item: T,
  englishField: string,
  frenchField: string,
  language: string
): string {
  const frenchValue = item[frenchField];
  const englishValue = item[englishField];
  
  return language.startsWith('fr') && frenchValue ? frenchValue : (englishValue || '');
} 